<template>
  <div>
    <top-bar heading="Stream Manager"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <!-- DRAFT STREAMS -->
      <div class="row">

        <div class="col-12">
          <h2>DRAFT STREAMS</h2>
          <h4>To edit draft streams, click the
            <font-awesome-icon icon="cog"></font-awesome-icon>
            icon.
          </h4>
        </div>
      </div>
      <div class="row mb-5">

        <!-- COURSES -->
        <div class="col-12 col-md-6 col-lg-3 card__alternate" v-for="stream in draftStreams" :key="'stream-' + stream.id">
          <div class="card" :class="{ 'card__disabled': stream.disabled }">
            <div class="float-right" style="position: absolute; right: 25px; top: 15px;">
              <span class="text-white mr-3 pointer">
                  <router-link :to="'/streams/' + stream.id" class="text-white"><font-awesome-icon icon="cog"></font-awesome-icon></router-link>
              </span>
              <span class="text-white pointer" @click="deleteStream(stream)">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </span>
            </div>
            <div class="card--feature card--feature__full">
              <div class="card--feature-text">{{ stream.stream.toUpperCase() }}</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <div class="card pointer" @click="createStream">
            <div class="card--feature card--feature__grey card--feature__full">
              <div class="card--feature-text">ADD NEW STREAM</div>
            </div>
          </div>
        </div>
      </div>
      <!-- /DRAFT STREAMS -->
      <!-- PUBLISHED STREAMS -->
      <div class="row">

        <div class="col-12">
          <h2>PUBLISHED STREAMS</h2>
          <h4>To edit draft streams, click the
            <font-awesome-icon icon="cog"></font-awesome-icon>
            icon.
          </h4>
        </div>
      </div>
      <div class="row">

        <!-- COURSES -->
        <div class="col-12 col-md-6 col-lg-3 card__alternate" v-for="stream in publishedStreams" :key="'stream-' + stream.id">
          <div class="card" :class="{ 'card__disabled': stream.disabled }">
            <div class="float-right" style="position: absolute; right: 25px; top: 15px;">
              <span class="mr-3 pointer">
                  <router-link :to="'/streams/' + stream.id" class="text-white"><font-awesome-icon icon="cog"></font-awesome-icon></router-link>
              </span>
              <span class="pointer" @click="deleteStream(stream)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
              </span>
            </div>
            <div class="card--feature card--feature__full">
              <div class="card--feature-text">{{ stream.stream.toUpperCase() }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- /DRAFT STREAMS -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'StreamManager',
  data () {
    return {
      loaded: false,
      streams: []
    };
  },
  computed: {
    draftStreams () {
      return this.streams.filter(stream => !stream.published);
    },
    publishedStreams () {
      return this.streams.filter(stream => stream.published);
    }
  },
  methods: {
    getStreams () {
      this.loaded = false;
      this.axios.get('/course_streams', {params: {order_by: 'updated_at,desc'}}).then(rsp => {
        this.streams = rsp.data;
        this.loaded = true;
      }).catch(err => this.$errorOut(err));
    },
    deleteStream (stream) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This will delete the selected Stream!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.delete('/course_streams/' + stream.id).then(() => {
            this.$snotify.success('Stream Deleted');
            this.getStreams();
          }).catch(err => this.$errorOut(err));
        }
      });
    },
    createStream () {
      this.axios.post('/course_streams', {stream: 'New Stream'}).then(rsp => {
        this.streams.push(rsp.data);
        this.$snotify.success('New Stream Created');
      });
    }
  },
  mounted () {
    this.getStreams();
  },
  metaInfo: {
    title: 'Stream Manager'
  }
};
</script>
